import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreButtonLabel: {
		id: 'software-releases-version-related-work.category-filter.more-lozenge.more-button-label',
		defaultMessage: '+{count} more',
		description:
			'The more button to display more related work categories, when the number of categories exceeds 5',
	},
});
